var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.667 17.5v-5h1.666v1.667H18v1.666h-6.667V17.5H9.667ZM3 15.833v-1.666h5v1.666H3ZM6.333 12.5v-1.667H3V9.167h3.333V7.5H8v5H6.333Zm3.334-1.667V9.167H18v1.666H9.667ZM13 7.5v-5h1.667v1.667H18v1.666h-3.333V7.5H13ZM3 5.833V4.167h8.333v1.666H3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllFilters);
export default __webpack_public_path__ + "static/media/all_filters.0bb2fe67ef56dd06d56e7430df11c155.svg";
export { ForwardRef as ReactComponent };